import i18n from '@/i18n';
import { ICurrency } from '@/mainComponent/store/interfaces/newInterfaces/ICurrency';
// import store from '@/store';

class Utils {
  static canvas: HTMLCanvasElement;

  static async delay(time: number): Promise<any> {
    return new Promise(resolve => {
      setTimeout(resolve, time);
    });
  }

  static parse(target: Record<string, null | any | undefined>, newObj: Record<string, null | any | undefined>) {
    Object.keys(newObj).forEach(key => {
      if (newObj[key] === null) return;

      if (typeof newObj[key] === 'object') {
        if (!target[key]) target[key] = newObj[key];
        Utils.parse(target[key], newObj[key]);
      } else target[key] = newObj[key];
    });
  }

  static parseGetParams(name: string): string | null {
    const params = new URLSearchParams(new URL(window.location.href).search);
    const result = params.get(name);
    if (!result) {
      console.error(`parameter '${name}' in url not found`);
    }
    return result;
  }

  static isInsertIntegration(): boolean {
    try {
      return Boolean(game) && Boolean(game.store) && Boolean(initConfig);
    } catch (err) {
      return false;
    }
  }

  static isLocalProject(): boolean {
    return Utils.isNumber(document.location.host[0]) || document.location.host.includes('localhost');
  }

  static isNumber(value: number | string): boolean {
    return !isNaN(Number(value));
  }

  static get getLinkForGameLogo(): string {
    const protocol: string = Utils.isLocalProject() ? 'https:' : document.location.protocol;
    const domain: string = this.getAssetsLink(protocol);
    return `${domain}/assets/games/`;
  }

  static getAssetsLink(protocol: string) {
    const originWindowURLParams = new URLSearchParams(new URL(window.location.href).search);
    const assetsPath = originWindowURLParams.get('assets');

    if (!assetsPath) {
      throw new Error('ASSETS PATH IS NOT DEFINED!!!!!');
    }

    return `${protocol}//${assetsPath}`;
  }

  static formatDate(date: Date): string {
    const Y: number = date.getFullYear();
    const M: number = date.getMonth() + 1;
    const D: number = date.getDate();
    const h: number = date.getHours();
    const m: number = date.getMinutes();

    const timeZoneOffset = -date.getTimezoneOffset() / 60;
    const timeZoneFormatted = `UTC${timeZoneOffset >= 0 ? '+' : ''}${
      Math.abs(timeZoneOffset) < 10 ? '0' : ''
    }${Math.abs(timeZoneOffset)}`;

    return (
      Y +
      '.' +
      (M < 10 ? '0' + M : M) +
      '.' +
      (D < 10 ? '0' + D : D) +
      ' ' +
      (h < 10 ? '0' + h : h) +
      ':' +
      (m < 10 ? '0' + m : m) +
      ' ' +
      timeZoneFormatted
    );
  }

  static centsToMoneyStr(
    cents: number,
    currencyDecimals: number,
    currencyCode: string,
    hideCents: boolean = false
  ): string {
    let arr: string[];
    const dv: number = Math.pow(10, currencyDecimals);
    const money: string = (cents / dv).toFixed(currencyDecimals);
    let value: string = money;

    if (currencyDecimals != 0) {
      arr = String(money).split('.');

      if (hideCents) {
        value = arr[0];
      }

      if (arr[1] == null) arr[1] = '00';
      else if (arr[1].length == 1) arr[1] += '0';
      value = arr[0] + '.' + arr[1];
    }
    // @ts-ignore
    const curencyData = window.promoApp.currencyList?.find((currency: ICurrency) => currency.name === currencyCode);
    if (curencyData) {
      value = this.formatCrypto(value, curencyData);
    }

    return value;
  }

  static formatCrypto(value: string, data: ICurrency): string {
    let formated = value;

    if (data.type === 'stable') {
      formated = this.normalize(value, data.minDecimals);
    } else if (data.type === 'crypto') {
      formated = this.formatToMili(value, data);
      // TODO: return after fix this function in slot-core
      // else formated = this.normalize(value, data.minDecimals);
    }

    return formated;
  }

  static normalize(value: string, minDecimals: number): string {
    const noZeros = parseFloat(value).toFixed(minDecimals);

    return noZeros;
  }

  static formatToMili(value: string, data: ICurrency): string {
    const modifier = data.mili ? 1000 : 1;
    const formated = (parseFloat(value) * modifier).toFixed(data.minDecimals);
    let stringifyValue = formated.toString();

    if (stringifyValue.length === 1) stringifyValue += '.00';
    return stringifyValue;
  }

  static formatCurrencyCodeToMili(value: string): string {
    // @ts-ignore
    const curencyData = window.promoApp.currencyList.find((currency: ICurrency) => currency.name === value);
    if (curencyData && curencyData.type === 'crypto' && curencyData.mili) {
      return 'm' + value;
    }
    return value;
  }

  static isFinishedTime(condition: boolean, time: string): boolean {
    if (!condition) return true;

    let deltaTime = (new Date(time).getTime() - new Date().getTime()) / 1000;

    deltaTime = Math.max(deltaTime, 0);

    return deltaTime <= 0;
  }

  static getTimeStandardFormat(time: string) {
    let deltaTime = (new Date(time).getTime() - new Date().getTime()) / 1000;
    deltaTime = Math.max(deltaTime, 0);
    if (deltaTime <= 0) return '00:00:00';

    let day: string | number = Math.floor(deltaTime / 60 / 60 / 24);
    let hour: string | number = Math.floor((deltaTime - day * 24 * 60 * 60) / 60 / 60);
    let min: string | number = Math.floor((deltaTime - day * 24 * 60 * 60 - hour * 60 * 60) / 60);
    let sec: string | number = Math.floor(deltaTime - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60);
    if (day < 10) day = '0' + day;
    if (hour < 10) hour = '0' + hour;
    if (min < 10) min = '0' + min;
    if (sec < 10) sec = '0' + sec;

    if (day <= 0) {
      return `${hour}:${min}:${sec}`;
    }

    return `${day}:${hour}:${min}`;
  }

  static getTimeForIcon(condition: boolean, time: string): string {
    if (!condition) return '';

    let deltaTime = (new Date(time).getTime() - new Date().getTime()) / 1000;
    deltaTime = Math.max(deltaTime, 0);

    const i18nMessages: any = i18n.messages[i18n.locale] || i18n.messages['en'];

    const options: { dayString: string; hourString: string; minString: string; secString: string } = {
      dayString: i18nMessages.timer_days,
      hourString: i18nMessages.timer_hours,
      minString: i18nMessages.timer_minutes,
      secString: i18nMessages.timer_seconds
    };

    return Utils.getTimeFormat(deltaTime, options);
  }

  static getTimeFormat(
    ms: number,
    options: { dayString: string; hourString: string; minString: string; secString: string } = {
      dayString: 'd',
      hourString: 'h',
      minString: 'm',
      secString: 's'
    }
  ): string {
    const day: number = Math.floor(ms / 60 / 60 / 24);
    const hour: number = Math.floor((ms - day * 24 * 60 * 60) / 60 / 60);
    const min: number = Math.floor((ms - day * 24 * 60 * 60 - hour * 60 * 60) / 60);
    const sec: number = Math.floor(ms - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60);

    if (day <= 0) {
      return `${hour}${options.hourString} ${min}${options.minString} ${sec}${options.secString}`;
    }

    return `${day}${options.dayString} ${hour}${options.hourString} ${min}${options.minString}`;
  }

  static loadCSSFont(name: string, url: string): void {
    const newStyle = document.createElement('style');
    newStyle.appendChild(document.createTextNode('@font-face{font-family: ' + name + '; src: url(' + url + ');}'));
    document.head.appendChild(newStyle);

    // необходимо  для предварительной загрузки шрифтов GT-3177
    const link = document.createElement('link');
    link.as = 'font';
    link.href = url;
    link.rel = 'preload';
    link.crossOrigin = '';
    link.type = 'font/otf';
    document.head.appendChild(link);
  }
}

export { Utils };
